<template>
  <div>
    <!-- <el-card style="text-align:left;margin-top: 16px;">
      <div class="recent">Tracking by Number</div>
      <el-input type="number" clearable :value="inputTracking" placeholder="Enter 13-digit tracking number" v-model="inputTracking" style="margin-top:12px;"><el-button @click="toTracking" slot="append" icon="el-icon-search"></el-button></el-input>
      <div style="margin-top:6px;text-align:left; color:#f56c6c" v-if="warningTxt !== ''">{{ warningTxt }}</div>
      <div style="margin-top: 12px;" v-show="showDetail">
        <div class="status" :style="postStyle.statusColor">{{ trackingDetail.status }}</div>
        <el-table
          :data="trackingDetail.detail"
          border
          style="width: 100%; margin-top:12px;">
          <el-table-column
            prop="time"
            label="Date">
          </el-table-column>
          <el-table-column
            prop="content"
            label="Status">
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <el-card style="text-align:left;margin-top: 24px;">
      <div class="recent">Recently Tracked</div>
      <div style="display:flex;justify-content:space-between;overflow:auto">
        <div v-for="item in recentTracking" :key="item.index" style="margin-top: 12px;">
          <el-button plain @click="toRecentTracking(item)" class="recent-number">
            <div class="normal">Tracking # <span class="bold">{{ item.number }}</span></div>
            <div class="normal">Ship to <span class="bold">{{ item.to }}</span></div>
            <div class="normal">Track Date<span class="bold">{{ item.date }}</span></div>
          </el-button>
        </div>
      </div>
    </el-card> -->
    <el-card style="text-align:left;margin-top: 24px;">
      <div class="recent">提示</div>
      <div style="margin-top: 12px;">运单查询功能将稍后开放</div>
      <div style="margin-top: 8px;">请您暂时选择在 韵达速递官网 或 快递100 查询您的运单。</div>
      <div style="margin-top: 8px; font-weight: bold">韵达速递 <a href="http://usa.yundaex.com/">http://usa.yundaex.com/</a></div>
      <div style="margin-top: 8px;font-weight: bold">快递100 <a href="https://www.kuaidi100.com/">https://www.kuaidi100.com/</a></div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Tracking',
  data () {
    return {
      recentTracking: [{
        number: '1234567890123',
        to: 'Jiahui Zhang',
        date: '2018-08-08'
      },
      {
        number: '1234567890124',
        to: 'Jiahui Zhang',
        date: '2018-08-08'
      },
      {
        number: '1234567890125',
        to: 'Jiahui Zhang',
        date: '2018-08-08'
      },
      {
        number: '1234567890126',
        to: 'Jiahui Zhang',
        date: '2018-08-08'
      },
      {
        number: '1234567890127',
        to: 'Jiahui Zhang',
        date: '2018-08-08'
      },
      {
        number: '1234567890123',
        to: 'Jiahui Zhang',
        date: '2018-08-08'
      }],
      inputTracking: '',
      trackingDetail: {
        number: '123456',
        statusNum: '2',
        status: '揽件，货物已由快递公司揽收并且产生了第一条跟踪信息',
        date: '',
        detail: [{
          time: '2018-08-08 12:56:00',
          content: '江苏泗阳县公司:进行揽件扫描'
        }]
      },
      showDetail: false,
      warningTxt: ''
    }
  },
  methods: {
    toRecentTracking: function (item) {
      this.inputTracking = item.number
    },
    toTracking: function () {
      if (this.inputTracking === '') {
        this.warningTxt = 'Please input 13-digit tracking number'
        return
      }
      if (this.inputTracking.length !== 13) {
        this.warningTxt = 'Tracking number should be 13 digits'
        return
      }
      // console.log('to track')
    }
  },
  computed: {
    postStyle: function () {
      let postStyle = {
        statusColor: '--statusColor: transparent'
      }
      if (this.trackingDetail.statusNum === '0' || this.trackingDetail.statusNum === '1' || this.trackingDetail.statusNum === '3' || this.trackingDetail.statusNum === '5') {
        postStyle.statusColor = '--statusColor: rgba(103,194,58,0.8)'
      }
      if (this.trackingDetail.statusNum === '2' || this.trackingDetail.statusNum === '4' || this.trackingDetail.statusNum === '6') {
        postStyle.statusColor = '--statusColor: rgba(245,108,108,0.8)'
      }
      return postStyle
    }
  }
}
</script>

<style>
:root {
  --statusColor: #ffffff;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}
.status {
  background-color: var(--statusColor);
  font-size: 14px;
  font-weight: bold;
  width: 100%;
  height: 48px;
  display: flex;
  /* justify-content: center; */
  align-items: center;
  justify-content: center;
}
.recent {
  font-family: Montserrat, sans-serif;
  margin-top: 8px;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.normal {
  height: 20px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6)
}
.bold {
  margin-left: 6px;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.9);
}
</style>
